import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import StepNavigator from 'Components/ComponentLibrary/Molecules/StepNavigator';
import { useHistory } from 'react-router-dom';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import { FDBox, FDStack } from '@facet-wealth/design';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';

const WizardCompleteStepTemplate = ({
  resource,
  content,
  onNext,
  onPrevious,
  template,
}) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const history = useHistory();

  const templateName = template || resource.type();
  const ContentComponent = content;

  const handleNext = async () => {
    logStandardizedEvent(categories.wizard, eventTypes.click, 'finish', { eventProperties: { templateName } });
    if (onNext) {
      await onNext();
    } else {
      history.push('/');
    }
  };
  const handleBack = async () => {
    logStandardizedEvent(categories.wizard, eventTypes.click, 'back', { eventProperties: { templateName } });
    await onPrevious();
  };
  return (
    <VerticalStack height="open">
      <FDStack direction={'column'} flex={1}>
        <FDStack spacing={2} direction={'column'} alignItems={'center'} paddingY={8} paddingX={1} flex={1}>
          <ImageRel height={'175px'} relationship={resource.relationship(fr.relationships.image.name)} />
          <FDBox maxWidth={600} paddingX={1}>
            <PageContentTop
              badgeImage={resource.attr('imageUrl')}
              title={resource.attr('title')}
              subtitle={resource.attr('subtitle')}
            />
          </FDBox>
          {content && (
            <FDStack direction={'column'} alignItems={'center'} flexGrow={1}>
              <ContentComponent resource={resource} />
            </FDStack>
          )}
        </FDStack>
        <StepNavigator
          onNext={handleNext}
          onPrevious={onPrevious ? handleBack : undefined}
        >
          {resource.attr('primaryActionText') || 'Finish'}
        </StepNavigator>
      </FDStack>
    </VerticalStack>
  );
};

WizardCompleteStepTemplate.defaultProps = {
  content: null,
  onNext: null, // By default go to the home page
  onPrevious: undefined,
  template: '',
};

WizardCompleteStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  content: PropTypes.element,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  template: PropTypes.string,
};

export default WizardCompleteStepTemplate;
